import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { Router } from '@angular/router';
import { LandingPageComponent } from '../landing-page/landing-page.component';
import { KingClubAssets } from '../../shared/enum/icons';

@Component({
  selector: 'app-account-switch-dialog',
  templateUrl: './account-switch-dialog.component.html',
  styleUrls: ['./account-switch-dialog.component.scss']
})
export class AccountSwitchDialogComponent implements OnInit {
  icons = KingClubAssets;
  constructor(
    public dialogRef: MatDialogRef<LandingPageComponent>,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  switchAccount() {

  }
  
  cancel() {
    this.dialogRef.close();
  }

}
